const KINDS = new Set(["runtime_error", "unhandled_rejection", "control_focus", "voice_change", "window_visible", "stream_failure"]);
const ERROR_NAMES = new Set(["Error", "TypeError", "ReferenceError", "SyntaxError", "RangeError", "AbortError", "NotAllowedError", "NotSupportedError"]);
const BOOLEAN_FIELDS = ["focused", "visible", "promptDisabled", "promptReadOnly", "isPaused", "externallyPaused", "showChat", "running"];
const NUMBER_FIELDS = ["promptLength", "textLength"];

export function createClientDiagnostics({ send, getState, now = Date.now }) {
  let period = now(), count = 0;
  const lastSent = new Map();
  return { report(kind, error) {
    try {
      if (!KINDS.has(kind)) return;
      const time = now();
      if (time - period >= 3600000) { period = time; count = 0; lastSent.clear(); }
      if (count >= 12 || (lastSent.has(kind) && time - lastSent.get(kind) < 60000)) return;
      const state = getState();
      const record = { version: 1, kind };
      for (const field of BOOLEAN_FIELDS) record[field] = Boolean(state[field]);
      for (const field of NUMBER_FIELDS) record[field] = Math.max(0, Math.min(1000000, Number(state[field]) || 0));
      if (["tia", "james", "rhythm", "theo", "almee", "brad", "nicole"].includes(state.voice)) record.voice = state.voice;
      if (["soft_new", "highest", "regular"].includes(state.style)) record.style = state.style;
      if (/^main\.[a-z0-9]{1,64}\.js$/.test(state.bundle || "")) record.bundle = state.bundle;
      if (ERROR_NAMES.has(error?.name)) record.errorName = error.name;
      count++;
      lastSent.set(kind, time);
      send(record);
    } catch (ignored) {}
  } };
}